<template>
  <main id="contact-us" style="background-color: #274c8e">
    <div class="bg-canvas">
      <div class="bg-gradient">

        <div class="auth-card">
          <img
            alt="efunding-logo"
            :src="require('@/assets/images/landing_page/img-logo-efunding.png')"
            class="logo-styles"
          />
          <span class="desc-text">Selamat Datang di Platform Efunding, Silahkan Masuk.</span>
          <form class="form-container">
            <input
              type="text"
              class="input-style"
              placeholder="Masukan Email"
            />
            <input
                type="text"
                class="input-style"
                placeholder="Masukan Password"
              />
            
            <div class="checkbox-wrapper-13">
              <input id="c1-13" type="checkbox" />
              <label for="c1-13">Tetap Masuk di Perangkat Ini</label>
            </div>
            <div class="register-button-container">
              <button class="button-blue">Masuk</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "NewLogin",
};
</script>
<style scoped>
.bg-canvas {
  background-image: url("../../assets/images/landing_page/img-bg-canvas.png");
  height: 100dvh;
}
.bg-gradient {
  background: linear-gradient(
    to top,
    rgba(39, 76, 142, 1) 49%,
    rgba(39, 76, 142, 0)
  );
  height: 100dvh;
  display: grid;
  place-content: center;
}
.auth-card {
  background-color: white;
  padding: 80px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 1064px;
  width: 1064px;
  align-items: center;
  border-radius: 15px;
}
.logo-styles {
  height: auto;
  width: 360px;
}
.sub-title-text {
  font-size: 38px;
  font-weight: 600;
  color: #274c8e;
}
.desc-text {
  font-size: 24px;
  font-weight: 500;
  color: #274c8e;
  text-align: center;
}
.selection-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
}
.selection-card {
  cursor: pointer;
  transition: all 0.3s;
}
.selection-card:hover {
  transform: scale(105%);
}
.helper-text {
  font-size: 20px;
  color: #274c8e;
  font-weight: 400 !important;
}

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  width: 100%;
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #274c8e;
}

.divider:not(:empty)::before {
  margin-right: 0.25em;
}

.divider:not(:empty)::after {
  margin-left: 0.25em;
}

.input-style {
  font-size: 18px;
  background-color: #ececec;
  border: 1px solid #6c6d70;
  color: #59595a;
  outline: none;
  border-radius: 10px;
  margin-top: 20px;
  padding: 10px;
  padding: 20px;
  width: 100%;
}
.form-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: start;
  width: 100%;
}
.flex {
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
}
.button-blue {
  padding: 15px 25px;
  background-color: #00a1ca;
  color: white;
  font-weight: 600;
  transition: all 0.5s;
  border: none;
  border-radius: 50px;
  width: 70%;
  font-size: 38px;
}
.button-blue:hover {
  transform: scale(105%);
}
.register-button-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
@supports (-webkit-appearance: none) or (-moz-appearance: none) {
  .checkbox-wrapper-13 input[type="checkbox"] {
    --active: #275efe;
    --active-inner: #fff;
    --focus: 2px rgba(39, 94, 254, 0.3);
    --border: #bbc1e1;
    --border-hover: #275efe;
    --background: #fff;
    --disabled: #f6f8ff;
    --disabled-inner: #e1e6f9;
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 21px;
    outline: none;
    display: inline-block;
    vertical-align: top;
    position: relative;
    margin: 0;
    cursor: pointer;
    border: 1px solid var(--bc, var(--border));
    background: var(--b, var(--background));
    transition: background 0.3s, border-color 0.3s, box-shadow 0.2s;
  }
  .checkbox-wrapper-13 input[type="checkbox"]:after {
    content: "";
    display: block;
    left: 0;
    top: 0;
    position: absolute;
    transition: transform var(--d-t, 0.3s) var(--d-t-e, ease),
      opacity var(--d-o, 0.2s);
  }
  .checkbox-wrapper-13 input[type="checkbox"]:checked {
    --b: var(--active);
    --bc: var(--active);
    --d-o: 0.3s;
    --d-t: 0.6s;
    --d-t-e: cubic-bezier(0.2, 0.85, 0.32, 1.2);
  }
  .checkbox-wrapper-13 input[type="checkbox"]:disabled {
    --b: var(--disabled);
    cursor: not-allowed;
    opacity: 0.9;
  }
  .checkbox-wrapper-13 input[type="checkbox"]:disabled:checked {
    --b: var(--disabled-inner);
    --bc: var(--border);
  }
  .checkbox-wrapper-13 input[type="checkbox"]:disabled + label {
    cursor: not-allowed;
  }
  .checkbox-wrapper-13
    input[type="checkbox"]:hover:not(:checked):not(:disabled) {
    --bc: var(--border-hover);
  }
  .checkbox-wrapper-13 input[type="checkbox"]:focus {
    box-shadow: 0 0 0 var(--focus);
  }
  .checkbox-wrapper-13 input[type="checkbox"]:not(.switch) {
    width: 21px;
  }
  .checkbox-wrapper-13 input[type="checkbox"]:not(.switch):after {
    opacity: var(--o, 0);
  }
  .checkbox-wrapper-13 input[type="checkbox"]:not(.switch):checked {
    --o: 1;
  }
  .checkbox-wrapper-13 input[type="checkbox"] + label {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    margin-left: 4px;
  }

  .checkbox-wrapper-13 input[type="checkbox"]:not(.switch) {
    border-radius: 7px;
  }
  .checkbox-wrapper-13 input[type="checkbox"]:not(.switch):after {
    width: 5px;
    height: 9px;
    border: 2px solid var(--active-inner);
    border-top: 0;
    border-left: 0;
    left: 7px;
    top: 4px;
    transform: rotate(var(--r, 20deg));
  }
  .checkbox-wrapper-13 input[type="checkbox"]:not(.switch):checked {
    --r: 43deg;
  }
}

.checkbox-wrapper-13 * {
  box-sizing: inherit;
}
.checkbox-wrapper-13 *:before,
.checkbox-wrapper-13 *:after {
  box-sizing: inherit;
}
</style>



// WEBPACK FOOTER //
// src/public/auth/newLogin.vue